export const getUniqueStr = (strong?: number): string => {
  let defaultStrong = 1000;
  if (strong) defaultStrong = strong;
  return (
    new Date().getTime().toString(16) +
    Math.floor(defaultStrong * Math.random()).toString(16)
  );
} 
